<div class="dashboard">
  <ng-content></ng-content>
</div>
